import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	ICreateSubcategoryModalContext,
	CreateSubcategoryModalContext,
} from '../../../../../../../../../createSubcategoryModalContext/createSubcategoryModalState/createSubcategoryModalContext';
import { Form, Checkbox } from 'antd';
import style from './AvailableForRepetitionCheckbox.module.scss';

const AvailableForRepetitionCheckbox: React.FC = () => {
	const { changeAvailableForRepetition, isAvailableForRepetition } =
		useContext<ICreateSubcategoryModalContext>(CreateSubcategoryModalContext);

	return (
		<Form.Item name="isAvailableForRepetition">
			<Checkbox
				onChange={(e) => changeAvailableForRepetition(e.target.checked)}
				checked={isAvailableForRepetition}>
				<Text
					className={style.checkboxName}
					translationNameSpace="form"
					translationKey="availableForRepetitionLabel"
				/>
			</Checkbox>
		</Form.Item>
	);
};

export default AvailableForRepetitionCheckbox;
